import templateUrl from './resources-list.html';

export const resourcesListComponent = {

    bindings: {
        details: '<'
    },

    templateUrl,
    controller: class ResourcesListComponent {

        constructor($state) {
            'ngInject';

            this.$state = $state;
        }
        $onInit() {
        }

        viewDetails(detail) {
            const { slug } = detail;
            this.$state.go('resourceCategory', { slug });
        }

    }
}





// WEBPACK FOOTER //
// ./src/app/components/resources/resources-list/resources-list.component.js